var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center"},[_c('div',{staticClass:"dashboard"},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"md":12}},[_c('nxs-admin-terms')],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"md":12}},[_c('nxs-admin-org-values')],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('nxs-dist-lists')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }